import type { Expense } from '#/graphql/types';
import { getWorkOrder, getWorkOrderList } from '#/graphql/queries';
import { gql } from '@apollo/client';
import { statusItems, typeItems } from './constants';
import FieldDefs from '#/types/FieldDefs';
import { getBaseColumns } from '#/common/utils/baseColumns';

const fields = {
  ...getBaseColumns(),
  id: {
    dataField: 'id',
    label: 'ID',
    editorOptions: { readOnly: true },
  },
  displayNumber: {
    dataField: 'displayNumber',
    label: 'Number',
    editorOptions: {
      readOnly: true,
      placeholder: 'Auto generated',
    },
  },
  type: {
    dataField: 'type',
    label: 'Type',
    isRequired: true,
    editorType: 'SelectBox',
    editorOptions: {
      placeholder: 'Choose an option',
      items: typeItems,
      displayExpr: 'label',
      valueExpr: 'key',
    },
  },
  title: {
    dataField: 'title',
    label: 'Title',
    isRequired: true,
  },
  description: {
    dataField: 'description',
    label: 'Description',
    editorType: 'TextArea',
    isRequired: true,
    editorOptions: {
      placeholder: 'Enter description',
      autoResizeEnabled: true,
      height: 100,
    },
  },

  workOrder: {
    dataField: 'workOrderId',
    label: 'Work Order',
    isRequired: true,
    editorType: 'RelatedItems',
    editorOptions: {
      placeholder: 'Search work orders...',
      button: {
        tooltip: 'View work order details',
        url: '/work-orders/:value/details',
        desktopOnly: false,
      },
      displayExpr: 'title',
      valueExpr: 'id',
      dataStoreOptions: {
        getItemList: gql(getWorkOrderList),
        getItem: gql(getWorkOrder),
        filter: [['is_archived', '=', 'false'], 'AND', ['state', '<>', 'closed']],
      },
    },
  },

  amount: {
    isRequired: true,
    dataField: 'amount',
    label: 'Amount',
    editorType: 'Currency',
    editorOptions: {
      placeholder: 'Enter amount',
      min: 0,
      step: 0.01,
      format: {
        type: 'currency',
        precision: 2,
      },
      showSpinButtons: true,
    },
  },
  status: {
    dataField: 'status',
    label: 'Status',
    editorType: 'SelectBox',
    editorOptions: {
      placeholder: 'Choose an option',
      items: statusItems,
      displayExpr: 'label',
      valueExpr: 'key',
    },
  },
  purchaseOrderId: {
    dataField: 'purchaseOrderId',
    label: 'PurchaseOrder',
  },
  tenant: {
    dataField: 'tenant.name',
    label: 'Organization',
    editorOptions: { readOnly: true },
  },
} satisfies FieldDefs<Expense>;

export default fields;
